import React from "react";
import { View, TouchableOpacity, Text, ActivityIndicator } from "react-native";
import i18n from "../../locales/i18n";
import { LinearGradient } from "expo-linear-gradient";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
  FadeInUp,
} from "react-native-reanimated";
interface Product {
  id_product: number;
  name: string;
}

interface ActionButtonsProps {
  selectedProduct: Product[];
  isChecked: boolean;
  setChecked: (checked: boolean) => void;
  buttonSpinner2: boolean;
  total: number;
  handelConfirm: () => void;
  locale: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  selectedProduct,
  buttonSpinner2,
  handelConfirm,
}) => {
  const scale = useSharedValue(1);
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }));

  return (
    <Animated.View
      entering={FadeInUp.duration(400).delay(200)}
      className="flex justify-between items-center my-2 px-4"
    >
      <Animated.View style={[{ width: "100%" }, animatedStyle]}>
        <TouchableOpacity
          disabled={selectedProduct.length == 0}
          activeOpacity={0.85}
          className={`${
            selectedProduct.length == 0 ? "opacity-40" : ""
          } rounded-[12px] w-full flex items-center justify-center`}
          onPressIn={() => {
            scale.value = withSpring(0.96, { damping: 15, stiffness: 300 });
          }}
          onPressOut={() => {
            scale.value = withSpring(1, { damping: 15, stiffness: 300 });
          }}
          onPress={handelConfirm}
        >
          <LinearGradient
            colors={["#004E6D", "#0596D0"]}
            locations={[0, 1]}
            className="w-full"
            style={{
              justifyContent: "center",
              alignItems: "center",
              paddingVertical: 14,
              borderRadius: 12,
            }}
          >
            {buttonSpinner2 ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text className="text-white text-2xl font-semibold">
                {i18n.t("confirm")}
              </Text>
            )}
          </LinearGradient>
        </TouchableOpacity>
      </Animated.View>
    </Animated.View>
  );
};

export default ActionButtons;
